<template>
  <el-dialog title="Alterar Carência do Repasse" @open="open" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="350px">
    <el-form :model="formValidate"
      :rules="validacao"
      ref="form" 
      size="small" 
      label-position="top" 
      hide-required-asterisk	
      :show-message="false" 
      style="padding:0;"
    >

      <el-row :gutter="10" style="margin-bottom: 20px;">
        <el-col :span="12">
          <el-form-item label="Aluguel">
            <el-input v-model="aluguel.idNaImobiliaria"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-bottom: 20px;">
        <el-col :span="24">
          <el-form-item label="Regra do Repasse">
            <el-select
              v-model="formValidate.regraRepasse"
              value-key="id"
              placeholder=""
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in regraRepasse"
                :key="item.data"
                :label="item.label"
                :value="item.data">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-bottom: 20px;">
        <el-col :span="12">
          <el-form-item label="Carência" prop="carenciaRepasse">
            <el-input v-model="formValidate.carenciaRepasse" v-mask="'##'">
              <template slot="append">dia(s)</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Mês Série" prop="primeiroMesSerie">
            <el-input v-model="formValidate.primeiroMesSerie" v-mask="'###'">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="">
              <el-checkbox v-model="somenteMesSerieSelecionado" label="Somente para o mês selecionado" name="somenteMesSerieSelecionado"></el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="alterar" type="primary" size="small" round class="btn-box-shadow">Alterar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { REGRA_REPASSE } from "../../../util/constantes.js";

export default {
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      formValidate: {
        carenciaRepasse: undefined,
        primeiroMesSerie: undefined,
        regraRepasse: undefined
      },
      somenteMesSerieSelecionado: false,
      validacao: {
        carenciaRepasse: [{ required: true }],
        primeiroMesSerie: [{ required: true }]
      }
    }
  },
  computed: {
    regraRepasse() {return REGRA_REPASSE},
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisContratosStore', [
      'alterarCarenciaAluguel'
    ]),
    open(){
      this.formValidate.regraRepasse = this.aluguel.regraRepasse;
    },
    alterar() {
      this.$refs["form"].validate(valid => {
        const formIsInvalid = !valid;
        if(formIsInvalid) {
          this.$message.warning("Informe os campos obrigatórios.")
          return;
        }
          let payload = {
            id: this.aluguel.id,
            carenciaRepasse: this.formValidate.carenciaRepasse,
            primeiroMesSerie: this.formValidate.primeiroMesSerie,
            somenteMesSerieSelecionado: this.somenteMesSerieSelecionado,
            regraRepasse: this.formValidate.regraRepasse === this.aluguel.regraRepasse ? undefined : this.formValidate.regraRepasse
          }

          this.showLoading();
          this.alterarCarenciaAluguel(payload)
          .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                break;
              default:
                this.$message.warning(resultado.mensagem);
                break;
            }
            this.fechar();
          }).catch(() => {
            this.fechar();
            this.hideLoading();
          });
      });
    },
    reset(){
      this.formValidate.carenciaRepasse = undefined
      this.formValidate.primeiroMesSerie = undefined
      this.somenteMesSerieSelecionado = false
      this.formValidate.regraRepasse = undefined
    },
    fechar() {
      this.reset()
      this.$emit('close');
    }, 
  }
}
</script>
